import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader, SiteFooter } from "@/components/site-chrome";
import { Breadcrumbs } from "@/components/breadcrumbs";
import { ContactSection } from "@/components/landing/contact-section";
import { breadcrumbJsonLd, SITE_URL, BRAND_OG_IMAGE, BRAND_OG_IMAGE_ALT, SITE_NAME } from "@/lib/seo";
import { useTranslation } from "react-i18next";
import { WHATSAPP_URL, LINKEDIN_URL, WhatsAppIcon, LinkedInIcon } from "@/components/social-links";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact Us | Smart Word Labs" },
      {
        name: "description",
        content:
          "Message the Smart Word Labs team about class timings, pricing or a free English assessment for your child. We reply within one working day.",
      },
      { property: "og:title", content: "Contact Us | Smart Word Labs" },
      {
        property: "og:description",
        content: "Send a message about classes, pricing or a free assessment. We reply within one working day.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_URL}/contact` },
      { property: "og:site_name", content: SITE_NAME },
      { property: "og:image", content: BRAND_OG_IMAGE },
      { property: "og:image:alt", content: BRAND_OG_IMAGE_ALT },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: BRAND_OG_IMAGE },
      { name: "twitter:image:alt", content: BRAND_OG_IMAGE_ALT },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/contact` }],
    scripts: [breadcrumbJsonLd([{ name: "Contact Us", path: "/contact" }])],
  }),
  component: ContactPage,
});

function ContactPage() {
  const { t } = useTranslation("pages");
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main>
        <div className="mx-auto max-w-6xl px-5 pt-6">
          <Breadcrumbs trail={[{ name: t("contact.breadcrumb"), path: "/contact" }]} />
          <h1 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-foreground sm:text-4xl">
            {t("contact.title")}
          </h1>
          <p className="mt-3 max-w-2xl text-base leading-relaxed text-muted-foreground">
            {t("contact.subtitle")}
          </p>
          <div className="mt-5 flex flex-col gap-2 text-base">
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-semibold text-primary underline decoration-accent underline-offset-4 hover:text-accent">
              <WhatsAppIcon className="size-5 text-whatsapp" />
              Prefer a quick chat? Message Ms. Salma on WhatsApp
            </a>
            <a href={LINKEDIN_URL} target="_blank" rel="noopener" className="inline-flex items-center gap-2 font-semibold text-primary underline decoration-accent underline-offset-4 hover:text-accent">
              <LinkedInIcon className="size-5" />
              View Ms. Salma's professional profile on LinkedIn
            </a>
          </div>
        </div>
        <ContactSection />
      </main>
      <SiteFooter />
    </div>
  );
}
